import { render, staticRenderFns } from "./ProjectFee.vue?vue&type=template&id=50b82da0"
import script from "./ProjectFee.vue?vue&type=script&lang=js"
export * from "./ProjectFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports